<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <signup-card class="aaaaa">
        <div  slot="close" class="closebtn">
          <span class="material-icons" style="color:gray;font-size:22px;" @click="goToLogin">
           close
          </span>
     
        </div>
        <h2 class="title text-center" slot="title">注 册</h2>
        <div
          class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 ml-auto"
          slot="content-left"
        >
          <div class="reg-info info-horizontal" v-for="item in contentLeft" :key="item.title">
            <div :class="`icon ${item.colorIcon}`">
              <md-icon>{{ item.icon }}</md-icon>
            </div>
            <div class="description">
              <h4 class="info-title">{{ item.title }}</h4>
              <p class="description">{{ item.description }}</p>
            </div>
          </div>
        </div>
        <div
          class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 mr-auto register"
          slot="content-right"
        >
          <div class="social-line text-center">
            <md-button class="md-just-icon md-round md-weixin" @click="noLogin">
              <i class="fab fa-weixin"></i>
            </md-button>
            <!-- <md-button class="md-just-icon md-round md-qq">
              <i class="fab fa-qq"></i>
            </md-button>-->
            <!-- <img src="@/assets/img/apple-icon.png" style="width:40px;height: 40px;" alt=""> -->
          </div>

          <md-field class="md-form-group">
            <md-icon>{{ inputs[0].icon }}</md-icon>
            <label>{{ inputs[0].name }}</label>
            <md-input
              v-model="inputs[0].nameAttr"
              :type="inputs[0].type"
              autocomplete="new-password"
              :placeholder="inputs[0].placeholder"
              @blur="numberFn"
            ></md-input>
            <p
              style="color: red; margin-bottom: 0px; position: absolute; left: 40px; top: 40px;font-size:12px;"
              v-if="isNumber"
            >{{isNumberText}}</p>
          </md-field>

          <md-field class="md-form-group">
            <md-icon>{{ inputs[1].icon }}</md-icon>
            <label>{{ inputs[1].name }}</label>
            <md-input
              v-model="inputs[1].nameAttr"
              :type="inputs[1].type"
              autocomplete="new-password"
              :placeholder="inputs[1].placeholder"
              @blur="passwordFn"
            ></md-input>
            <p
              style="color: red; margin-bottom: 0px; position: absolute; left: 40px; top: 40px;font-size:12px;"
              v-if="isPassword"
            >{{isPasswordText}}</p>
          </md-field>
          <md-field class="md-form-group">
            <md-icon>{{ inputs[2].icon }}</md-icon>
            <label>{{ inputs[2].name }}</label>
            <md-input
              v-model="inputs[2].nameAttr"
              :type="inputs[2].type"
              autocomplete="new-password"
              :placeholder="inputs[2].placeholder"
              @change="rePassword"
            ></md-input>
            <p
              style="color: red; margin-bottom: 0px; position: absolute; left: 40px; top: 40px;font-size:12px;"
              v-if="isRePassword"
            >{{isRePasswordText}}</p>
          </md-field>

          <!-- <el-tooltip v-model="visible" class="item" :offset="10"  content="请勾选同意后登录" placement="top-start" effect="dark"> -->
          <p class="tooiptip" v-if="isboolean">请勾选同意后登录</p>
          <md-checkbox v-model="boolean">
            注册即表示我已阅读并同意
            <a>《元学合作协议》</a>
          </md-checkbox>

          <div class="button-container">
            <md-button @click="register" href class="md-success md-round mt-4" slot="footer">确 定</md-button>
          </div>
        </div>
      </signup-card>
    </div>
  </div>
</template>
<script>
import { SignupCard } from '@/components';
import { register } from '@/api/user';

export default {
  components: {
    SignupCard,
  },
  data() {
    return {
      isboolean: false,
      visible: true,
      firstname: null,
      boolean: false,
      email: null,
      password: null,
      contentLeft: [
        {
          colorIcon: 'icon-success',
          icon: 'public',
          title: '元学',
          description: '从最小的单元开始，我们也能构造世界的复杂逻辑',
        },

        {
          colorIcon: 'icon-danger',
          icon: 'psychology',
          title: '人工智能',
          description: '持续迭代的赋予元件能力，将使我们开发实训任务的工作量有效缩减',
        },

        {
          colorIcon: 'icon-info',
          icon: 'view_in_ar',
          title: '虚拟现实',
          description: '对现实世界的映射，不是简单的拍照，需要重塑依托现实的虚拟空间构造规则',
        },
      ],
      inputs: [
        {
          icon: 'people',
          name: '账号',
          nameAttr: '',
          type: 'username',
          key: 'username',
          placeholder: '账号设置成功后不可更改',
          nullplaceholder: '账号不能为空',
        },

        {
          icon: 'lock_outline',
          name: '密 码',
          nameAttr: '',
          type: 'password',
          key: 'password',
          placeholder: '6-20位字母、数字或符号',
          nullpassword: '密码不能为空',
        },
        {
          icon: 'lock_outline',
          name: '确认密码',
          nameAttr: '',
          type: 'password',
          key: 'repassword',
          placeholder: '再次输入您的登录密码',
        },
      ],

      isNumber: false,
      isNumberText: '账号不能为空',
      isPassword: false,
      isPasswordText: '密码不能为空',
      isRePassword: false,
      isRePasswordText: '请再次输入密码',
    };
  },
  watch: {
    boolean(news) {
      if (!news) {
        this.isboolean = true;
      } else {
        this.isboolean = false;
      }
    },
    // inputs: {
    //   handler(val) {

    //     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //     const isValidEmail = emailRegex.test(val[0].nameAttr);
    //     const phoneRegex = /^1[3456789]\d{9}$/;
    //     const isValidPhone = phoneRegex.test(val[0].nameAttr);
    //     if(val[0].nameAttr==''){
    //       this.isNumberText='账号不能为空'
    //       this.isNumber = true;

    //     }else{
    //         if (isValidEmail || isValidPhone) {
    //         this.isNumber = false;
    //         } else {
    //         this.isNumber = true;
    //               this.isNumberText='账号只能为手机号码或邮箱'
    //         }
    //     }

    //   },
    //   deep: true,
    //   immediate: true, // 立即执行监听
    // },
  },
  methods: {
    goToLogin(){
        this.$router.push("/dashboard")
    },
    numberFn() {
      let res = false;
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValidEmail = emailRegex.test(this.inputs[0].nameAttr);
      const phoneRegex = /^1[3456789]\d{9}$/;
      const isValidPhone = phoneRegex.test(this.inputs[0].nameAttr);
      if (this.inputs[0].nameAttr == '') {
        this.isNumberText = '账号不能为空';
        this.isNumber = true;
        res = false;
        this.$store.dispatch('global/showWarningMsg', this.isNumberText);
      } else {
        if (isValidEmail || isValidPhone) {
          this.isNumber = false;
          this.isNumberText = '';
          res = true;
        } else {
          this.isNumber = true;
          this.isNumberText = '请输入正确的手机号码或邮箱';
          res = false;
          this.$store.dispatch('global/showWarningMsg', this.isNumberText);
        }
      }

      return res;
    },

    passwordFn() {
      let res = false;
      if (this.inputs[1].nameAttr == '') {
        this.isPassword = true;
        this.isPasswordText = '密码不能为空';
        res = false;
        this.$store.dispatch('global/showWarningMsg', this.isPasswordText);
      } else {
        const regex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,20}$/;
        regex.test(this.inputs[1].nameAttr)
        if(regex.test(this.inputs[1].nameAttr)){
            this.isPassword = false;
            res = true;
            this.isPasswordText = '';
        }else{
            this.isPassword = true;
            res = false;
            this.isPasswordText = '6-20位字母、数字或符号';

        }

      }
      return res;
    },

    rePassword() {
      let res = false;
      if (this.inputs[2].nameAttr == '') {
        this.isRePassword = true;
        this.isRePasswordText = '请再次输入密码';
        res = false;
        this.$store.dispatch('global/showWarningMsg', this.isRePasswordText);
      } else {
        // const regex = /^[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,20}$/;
        // regex.test(this.inputs[2].nameAttr)
           if(this.inputs[1].nameAttr == this.inputs[2].nameAttr){
                  this.isRePassword = false;
                  this.isRePasswordText = '';
                  res = true;
           }else{
                this.isRePassword = true;
                this.isRePasswordText = '密码不一致请重新输入';
                // this.$store.dispatch('global/showWarningMsg', this.isRePasswordText);
                res = false;
           }
      }
      return res;
    },

    noLogin() {
      this.$store.dispatch('global/showWarningMsg', '微信登录功能暂未开放');
    },
    register(params) {
      let res = true;
      if (this.numberFn() && this.passwordFn() && this.rePassword()) {
        if (this.inputs[1].nameAttr == this.inputs[2].nameAttr) {
          if (!this.boolean) {
            this.isboolean = true;
            this.$Msg('请阅读并同意《元学合作协议》');
            res = false;
            return;
          } else {
            this.isboolean = false;
            this.isRePassword = false;
            this.isRePasswordText = '';
            res = true;
          }
        }else{
    
          this.isRePassword = true;
          this.isRePasswordText = '密码不一致请重新输入';
          this.$store.dispatch('global/showWarningMsg', this.isRePasswordText);
          res = false;
   
        }
      }else{
        res =false;
      }

      if (res) {
        let tempData = {
            username: this.inputs[0].nameAttr,
            password: this.inputs[1].nameAttr,
            repassword: this.inputs[2].nameAttr,
        };
        register(tempData).then(res => {
          if (res.code === '200') {
            this.$store.dispatch('global/showSuccessMsg', '注册成功');
            setTimeout(() => {
              this.$router.push({ name: 'Login' });
            }, 1500);
          }
        });
      }
      return;
    },
  },
};
</script>
<style scoped>
.md-form-group {
  position: relative;
}

.register {
  position: relative;
}
.tooiptip {
  position: absolute;
  bottom: 113px;
  left: -26px;
  width: 109px;
  height: 21px;
  line-height: 18px;
  background: #101010a6;
  color: #fff;
  padding: 2px 5px;
  font-size: 12px;
  border-radius: 3px;
  text-align: center;
  margin-bottom: 0px !important;
}
.tooiptip:after {
  display: block;
  float: left;
  content: '';
  border-color: #101010a6 #fff #fff #fff;
  border-style: solid;
  border-width: 6px 6px 0 6px;
  height: 0;
  width: 0;
  transform: translate(40px, 1px);
}

.aaaaa{
  position: relative;
}
.closebtn{
  position: absolute;
   top: 8px;
   right: 8px;
   cursor: pointer;
}
/* .triangleDiv{
            border-color: #57af1a #fff #fff #fff;
            border-style: solid;
            border-width: 100px 60px 0 60px;
            height: 0;
            width: 0;
        } */

/* 
.register{
  padding-top: 20;
} */
</style>
